export type AuthClient = typeof import("../authClient").authClient;

let clientRequest: Promise<AuthClient> | null = null;

export function loadAuthClient(): Promise<AuthClient> {
  if (!clientRequest) {
    clientRequest = import("../authClient").then(({ authClient }) => authClient);
  }
  return clientRequest;
}
